import { useTranslation } from "react-i18next";
import { useMaintenanceStatus } from "@/api/organizationStatus.api";
import MaintenanceIcon from "./assets/svg/MaintenanceIcon";
import styles from "./MaintenanceBanner.module.scss";

const MaintenanceBanner = () => {
  const { t } = useTranslation();
  const isMaintenance = useMaintenanceStatus();

  if (!isMaintenance) return null;

  return (
    <div className={styles.maintenanceBanner} role="status">
      <MaintenanceIcon className={styles.icon} aria-hidden />
      {t("maintenance.inProgress")}
    </div>
  );
};

export default MaintenanceBanner;
